// extracted by mini-css-extract-plugin
export default {"popup__wrapper":"styles_popup__wrapper__ER1tq","active":"styles_active__v-9uo","popup_content":"styles_popup_content__RIdFa","popup_close":"styles_popup_close__SSo0a"};